<template>
    <div class="d-inline">
        <button type="button" class="btn btn-sm shadow-sm btn-outline-secondary" data-toggle="modal"
                data-target="#schedule-modal">
            {{ buttonText }}
            <span v-if="next">(Aktiv)</span>
        </button>
        <div class="modal fade" id="schedule-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ title }}
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" value="" id="schedule-active"
                                   v-model="schedule.active">
                            <label class="form-check-label" for="schedule-active">
                                Aktiv
                            </label>
                        </div>

                        <div class="alert alert-info" role="alert" v-if="next">
                            Nächste Ausführung:
                            <span :title="next.nextRunAtDiff">{{ next.nextRunAt }}</span>
                        </div>

                        <div class="form-group">
                            <label>Wiederholung</label>
                            <select class="form-control" v-model="schedule.intervalMode"
                                    @change="schedule.interval = '1'">
                                <option value="weekly">Wöchentlich</option>
                                <option value="monthly">Monatlich</option>
                                <option value="quarterly">Quartalsweise (erster Monat)</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Wiederholung zum</label>
                            <select class="form-control" v-model="schedule.interval">
                                <template v-if="schedule.intervalMode === 'weekly'">
                                    <option value="1">Montag</option>
                                    <option value="2">Dienstag</option>
                                    <option value="3">Mittwoch</option>
                                    <option value="4">Donnerstag</option>
                                    <option value="5">Freitag</option>
                                    <option value="6">Samstag</option>
                                    <option value="7">Sonntag</option>
                                </template>
                                <template v-if="schedule.intervalMode !== 'weekly'">
                                    <option :value="i" v-for="i in range(31)">{{ i }}.</option>
                                </template>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Datum Auswertung</label>
                            <select class="form-control" v-model="schedule.dateMode">
                                <option value="end">Nur Enddatum verschieben</option>
                                <option value="startAndEnd">Start- und Enddatum verschieben</option>
                                <option value="none">Nichts verschieben</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Titel</label>
                            <input type="text" class="form-control" v-model="schedule.title">
                            <div>
                                <div>
                                    <small class="text-muted">Platzhalter:</small>
                                </div>
                                <div class="mb-1">
                                    <button type="button" class="btn btn-sm btn-secondary" @click="addTitle('#datum')">
                                        Datum (01/22)
                                    </button>
                                    <button type="button" class="btn btn-sm btn-secondary"
                                            @click="addTitle('#quartal')">
                                        Quartal (Q1)
                                    </button>
                                    <button type="button" class="btn btn-sm btn-secondary" @click="addTitle('#monat')">
                                        Monat (Januar)
                                    </button>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-sm btn-secondary"
                                            @click="addTitle('#zeitraum')">
                                        Zeitraum (01/22 - 12/22)
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-primary" @click="save">
                                Speichern
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Schließen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        token: {
            type: String,
            required: true
        },
        scheduleUrl: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            default: 'Wiedervorlage'
        },
        title: {
            type: String,
            default: 'Wiedervorlage verwalten'
        }
    },
    data() {
        return {
            schedule: {
                active: false,
                title: '',
                dateMode: 'end',
                intervalMode: 'weekly',
                interval: '1',
                lastRunAt: null,
                lastRunAtDiff: null,
                nextRunAt: null,
                nextRunAtDiff: null,
            },
            calculation: {
                title: ''
            },
            next: null
        };
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            axios.get(this.scheduleUrl).then((res) => {
                if (res.data.schedule) {
                    this.schedule = res.data.schedule;
                } else {
                    this.schedule.title = res.data.calculation.title;
                }
                this.next = res.data.next;
            });
        },
        range(max) {
            return [...Array(max).keys()].map((i) => {
                return String(i + 1);
            });
        },
        addTitle(text) {
            this.schedule.title += ' ' + text;
        },
        save() {
            axios.post(this.scheduleUrl, {
                _token: this.token,
                schedule: this.schedule,
            }).catch(() => {
                alert("Fehler");
            }).finally(() => {
                this.fetch();
                if (this.schedule.active) {
                    if (!$('#keep-toggle-checkbox').prop('checked')) {
                        $('#keep-toggle').click();
                    }
                }
            });
        },
    },
}
</script>

<style scoped>

</style>
